import {
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
} from "chart.js";
import { useEffect, useState } from "react";
import { Line } from "react-chartjs-2";
import { LIVE_URL } from "../../../../config/config";
import useAuthToken from "../../../../hooks/useAuthToken";
import Styles from "../css/LineChart.module.scss";

ChartJS.register(
  CategoryScale,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend
);

const options = {
  responsive: true,
  plugins: {
    legend: {
      display: false,
      position: "top",
      labels: {
        color: "#fff",
      },
    },
    title: {
      display: false,
    },
  },
  scales: {
    x: {
      ticks: {
        color: "#fff",
      },
    },
    y: {
      ticks: {
        color: "#fff",
      },
    },
  },
};

const LineChart = () => {
  const { token, loading } = useAuthToken();
  const [open, setOpen] = useState(false);
  const [view, setView] = useState("monthly");
  const [year, setYear] = useState(new Date().getFullYear());
  const [chartData, setChartData] = useState(null);
  const [filterOpen, setFilterOpen] = useState(false);

  const filters = [
    { label: "Yearly", value: "yearly" },
    { label: "Monthly", value: "monthly" },
    { label: "Daily", value: "daily" },
  ];

  const apiTypeMap = {
    yearly: "yearly",
    monthly: "monthly",
    daily: "daily",
  };

  const formatLabel = (label, view) => {
    if (view === "yearly") {
      return label;
    }

    if (view === "monthly") {
      return label;
    }

    if (view === "daily") {
      const date = new Date(label);
      return date.toLocaleDateString("en-US", { weekday: "short" }).charAt(0);
    }
    return label;
  };
  const WEEK_ORDER = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

  //   const fetchChartData = async () => {
  //     try {
  //       const response = await fetch(
  //         `${LIVE_URL}/admin/total-active-users?type=${apiTypeMap[view]}`,
  //         {
  //           headers: { Authorization: `Bearer ${token}` },
  //         }
  //       );

  //       const result = await response.json();
  //       const graphData = result?.data?.graph_data;

  //       if (!graphData) {
  //         setChartData(null);
  //         return;
  //       }

  //       const sortedEntries = Object.entries(graphData).sort(
  //         ([a], [b]) => new Date(a) - new Date(b)
  //       );

  //       const labels = sortedEntries.map(([key]) => formatLabel(key, view));

  //       const values = sortedEntries.map(([, value]) => value);

  //       setChartData({
  //         labels,
  //         datasets: [
  //           {
  //             label: `${view.toUpperCase()} Active Users`,
  //             data: values,
  //             borderColor: "#e94057",
  //             backgroundColor: "#e94057",
  //             tension: view === "monthly" ? 0.3 : 0,
  //             fill: false,
  //             pointRadius: 4,
  //           },
  //         ],
  //       });
  //     } catch (error) {
  //       console.error("Chart API error:", error);
  //       setChartData(null);
  //     }
  //   };
  const fetchChartData = async () => {
    try {
      const response = await fetch(
        `${LIVE_URL}/admin/total-active-users?type=${apiTypeMap[view]}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      const result = await response.json();
      const graphData = result?.data?.graph_data;

      if (!graphData) {
        setChartData(null);
        return;
      }

      let sortedEntries;

      if (view === "daily") {
        sortedEntries = Object.entries(graphData).sort(
          ([a], [b]) => WEEK_ORDER.indexOf(a) - WEEK_ORDER.indexOf(b)
        );
      } else {
        sortedEntries = Object.entries(graphData);
      }

      const labels = sortedEntries.map(([key]) => key);
      const values = sortedEntries.map(([, value]) => value);

      setChartData({
        labels,
        datasets: [
          {
            label: `${view.toUpperCase()} Active Users`,
            data: values,
            borderColor: "#e94057",
            backgroundColor: "#e94057",
            tension: 0.3,
            pointRadius: 4,
          },
        ],
      });
    } catch (error) {
      console.error("Chart API error:", error);
      setChartData(null);
    }
  };
  useEffect(() => {
    if (!token || loading) return;
    fetchChartData();
  }, [view, token, loading]);

  return (
    <>
      <div className={Styles.controls}>
        <h2>Login User</h2>

        <div className={Styles.filter_select}>
          <div className={Styles.dropdown_wrapper}>
            <div
              className={Styles.dropdown_selected}
              onClick={() => setFilterOpen(!filterOpen)}
            >
              <span className={Styles.year_text}>
                {filters.find((f) => f.value === view)?.label}
              </span>
              <span className={Styles.dropdown_arrow}>
                {filterOpen ? "▲" : "▼"}
              </span>
            </div>
            {filterOpen && (
              <div className={Styles.dropdown_list}>
                {filters.map((item) => (
                  <div
                    key={item.value}
                    className={`${Styles.dropdown_item} ${
                      view === item.value ? Styles.selected : ""
                    }`}
                    onClick={() => {
                      setView(item.value);
                      setFilterOpen(false);
                    }}
                  >
                    {item.label}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>

      {chartData && <Line data={chartData} options={options} />}
    </>
  );
};

export default LineChart;
